export const IP_ORGANISMOS_FILTERS = [
  {
    name: 'tipo_instalacion',
    comboId: 'tipo_instalacion',
    multiple: true,
  },
  {
    name: 'empresa_ip_id',
    multiple: true,
    filterType: 'autocomplete',
  },

  // {
  //   name: 'nombre_empresa',
  //   // Search by name
  // },
  {
    name: 'fecha_creacion_inicio',
    filterType: 'date',
    maxDateField: 'fecha_creacion_fin',
  },
  {
    name: 'fecha_creacion_fin',
    filterType: 'date',
    minDateField: 'fecha_creacion_inicio',
  },
  {
    name: 'fecha_inspeccion_inicio',
    filterType: 'date',
    maxDateField: 'fecha_inspeccion_fin',
  },
  {
    name: 'fecha_inspeccion_fin',
    filterType: 'date',
    minDateField: 'fecha_inspeccion_inicio',
  },
]
